// source: xcommon/hr.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var xcommon_common_pb = require('../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
goog.exportSymbol('proto.xcommon.Archive', null, global);
goog.exportSymbol('proto.xcommon.ArchiveAttachment', null, global);
goog.exportSymbol('proto.xcommon.ArchiveAttachments', null, global);
goog.exportSymbol('proto.xcommon.ArchiveContact', null, global);
goog.exportSymbol('proto.xcommon.ArchiveFamily', null, global);
goog.exportSymbol('proto.xcommon.ArchiveIdentity', null, global);
goog.exportSymbol('proto.xcommon.ArchiveOccupancy', null, global);
goog.exportSymbol('proto.xcommon.ArchiveOccupancys', null, global);
goog.exportSymbol('proto.xcommon.ArchiveOffice', null, global);
goog.exportSymbol('proto.xcommon.ArchivePanelStatus', null, global);
goog.exportSymbol('proto.xcommon.ArchivePersonal', null, global);
goog.exportSymbol('proto.xcommon.ArchiveReward', null, global);
goog.exportSymbol('proto.xcommon.ArchiveRewards', null, global);
goog.exportSymbol('proto.xcommon.ArchiveWork', null, global);
goog.exportSymbol('proto.xcommon.DeleteArchiveReq', null, global);
goog.exportSymbol('proto.xcommon.DeleteArchiveResp', null, global);
goog.exportSymbol('proto.xcommon.Gender', null, global);
goog.exportSymbol('proto.xcommon.GetArchiveReq', null, global);
goog.exportSymbol('proto.xcommon.GetArchiveResp', null, global);
goog.exportSymbol('proto.xcommon.GetOfficeListReq', null, global);
goog.exportSymbol('proto.xcommon.GetOfficeListResp', null, global);
goog.exportSymbol('proto.xcommon.MaritalStatus', null, global);
goog.exportSymbol('proto.xcommon.OfficeStatus', null, global);
goog.exportSymbol('proto.xcommon.Relationship', null, global);
goog.exportSymbol('proto.xcommon.RewardCategory', null, global);
goog.exportSymbol('proto.xcommon.RewardItem', null, global);
goog.exportSymbol('proto.xcommon.RewardType', null, global);
goog.exportSymbol('proto.xcommon.SaveArchiveReq', null, global);
goog.exportSymbol('proto.xcommon.SaveArchiveResp', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOfficeListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetOfficeListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOfficeListReq.displayName = 'proto.xcommon.GetOfficeListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOfficeListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetOfficeListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetOfficeListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOfficeListResp.displayName = 'proto.xcommon.GetOfficeListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetArchiveReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetArchiveReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetArchiveReq.displayName = 'proto.xcommon.GetArchiveReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetArchiveResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetArchiveResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetArchiveResp.displayName = 'proto.xcommon.GetArchiveResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveArchiveReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveArchiveReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveArchiveReq.displayName = 'proto.xcommon.SaveArchiveReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveArchiveResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveArchiveResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveArchiveResp.displayName = 'proto.xcommon.SaveArchiveResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DeleteArchiveReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DeleteArchiveReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DeleteArchiveReq.displayName = 'proto.xcommon.DeleteArchiveReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DeleteArchiveResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DeleteArchiveResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DeleteArchiveResp.displayName = 'proto.xcommon.DeleteArchiveResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.Archive = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.Archive, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.Archive.displayName = 'proto.xcommon.Archive';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchivePersonal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ArchivePersonal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchivePersonal.displayName = 'proto.xcommon.ArchivePersonal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchiveIdentity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ArchiveIdentity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchiveIdentity.displayName = 'proto.xcommon.ArchiveIdentity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchiveWork = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ArchiveWork, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchiveWork.displayName = 'proto.xcommon.ArchiveWork';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchiveContact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ArchiveContact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchiveContact.displayName = 'proto.xcommon.ArchiveContact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchiveFamily = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ArchiveFamily.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ArchiveFamily, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchiveFamily.displayName = 'proto.xcommon.ArchiveFamily';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchiveOccupancys = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ArchiveOccupancys.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ArchiveOccupancys, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchiveOccupancys.displayName = 'proto.xcommon.ArchiveOccupancys';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchiveOccupancy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ArchiveOccupancy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchiveOccupancy.displayName = 'proto.xcommon.ArchiveOccupancy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchiveRewards = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ArchiveRewards.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ArchiveRewards, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchiveRewards.displayName = 'proto.xcommon.ArchiveRewards';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchiveReward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ArchiveReward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchiveReward.displayName = 'proto.xcommon.ArchiveReward';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchiveOffice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ArchiveOffice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchiveOffice.displayName = 'proto.xcommon.ArchiveOffice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchiveAttachments = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ArchiveAttachments.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ArchiveAttachments, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchiveAttachments.displayName = 'proto.xcommon.ArchiveAttachments';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ArchiveAttachment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ArchiveAttachment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ArchiveAttachment.displayName = 'proto.xcommon.ArchiveAttachment';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOfficeListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOfficeListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOfficeListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOfficeListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    archiveid: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOfficeListReq}
 */
proto.xcommon.GetOfficeListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOfficeListReq;
  return proto.xcommon.GetOfficeListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOfficeListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOfficeListReq}
 */
proto.xcommon.GetOfficeListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setArchiveid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOfficeListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOfficeListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOfficeListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOfficeListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getArchiveid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetOfficeListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetOfficeListReq} returns this
*/
proto.xcommon.GetOfficeListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOfficeListReq} returns this
 */
proto.xcommon.GetOfficeListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOfficeListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetOfficeListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetOfficeListReq} returns this
*/
proto.xcommon.GetOfficeListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOfficeListReq} returns this
 */
proto.xcommon.GetOfficeListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOfficeListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 UserID = 3;
 * @return {number}
 */
proto.xcommon.GetOfficeListReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetOfficeListReq} returns this
 */
proto.xcommon.GetOfficeListReq.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 ArchiveID = 4;
 * @return {number}
 */
proto.xcommon.GetOfficeListReq.prototype.getArchiveid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetOfficeListReq} returns this
 */
proto.xcommon.GetOfficeListReq.prototype.setArchiveid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetOfficeListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOfficeListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOfficeListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOfficeListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOfficeListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.ArchiveOffice.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOfficeListResp}
 */
proto.xcommon.GetOfficeListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOfficeListResp;
  return proto.xcommon.GetOfficeListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOfficeListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOfficeListResp}
 */
proto.xcommon.GetOfficeListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.ArchiveOffice;
      reader.readMessage(value,proto.xcommon.ArchiveOffice.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOfficeListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOfficeListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOfficeListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOfficeListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.ArchiveOffice.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetOfficeListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetOfficeListResp} returns this
*/
proto.xcommon.GetOfficeListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOfficeListResp} returns this
 */
proto.xcommon.GetOfficeListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOfficeListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetOfficeListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetOfficeListResp} returns this
*/
proto.xcommon.GetOfficeListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOfficeListResp} returns this
 */
proto.xcommon.GetOfficeListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOfficeListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated ArchiveOffice List = 3;
 * @return {!Array<!proto.xcommon.ArchiveOffice>}
 */
proto.xcommon.GetOfficeListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.ArchiveOffice>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ArchiveOffice, 3));
};


/**
 * @param {!Array<!proto.xcommon.ArchiveOffice>} value
 * @return {!proto.xcommon.GetOfficeListResp} returns this
*/
proto.xcommon.GetOfficeListResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.ArchiveOffice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ArchiveOffice}
 */
proto.xcommon.GetOfficeListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.ArchiveOffice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetOfficeListResp} returns this
 */
proto.xcommon.GetOfficeListResp.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetArchiveReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetArchiveReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetArchiveReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetArchiveReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    archiveid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    userid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetArchiveReq}
 */
proto.xcommon.GetArchiveReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetArchiveReq;
  return proto.xcommon.GetArchiveReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetArchiveReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetArchiveReq}
 */
proto.xcommon.GetArchiveReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setArchiveid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetArchiveReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetArchiveReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetArchiveReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetArchiveReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getArchiveid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetArchiveReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetArchiveReq} returns this
*/
proto.xcommon.GetArchiveReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetArchiveReq} returns this
 */
proto.xcommon.GetArchiveReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetArchiveReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 ArchiveID = 2;
 * @return {number}
 */
proto.xcommon.GetArchiveReq.prototype.getArchiveid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetArchiveReq} returns this
 */
proto.xcommon.GetArchiveReq.prototype.setArchiveid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 UserID = 3;
 * @return {number}
 */
proto.xcommon.GetArchiveReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetArchiveReq} returns this
 */
proto.xcommon.GetArchiveReq.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetArchiveResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetArchiveResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetArchiveResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetArchiveResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    archive: (f = msg.getArchive()) && proto.xcommon.Archive.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetArchiveResp}
 */
proto.xcommon.GetArchiveResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetArchiveResp;
  return proto.xcommon.GetArchiveResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetArchiveResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetArchiveResp}
 */
proto.xcommon.GetArchiveResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.Archive;
      reader.readMessage(value,proto.xcommon.Archive.deserializeBinaryFromReader);
      msg.setArchive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetArchiveResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetArchiveResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetArchiveResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetArchiveResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getArchive();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.Archive.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetArchiveResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetArchiveResp} returns this
*/
proto.xcommon.GetArchiveResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetArchiveResp} returns this
 */
proto.xcommon.GetArchiveResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetArchiveResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Archive Archive = 2;
 * @return {?proto.xcommon.Archive}
 */
proto.xcommon.GetArchiveResp.prototype.getArchive = function() {
  return /** @type{?proto.xcommon.Archive} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Archive, 2));
};


/**
 * @param {?proto.xcommon.Archive|undefined} value
 * @return {!proto.xcommon.GetArchiveResp} returns this
*/
proto.xcommon.GetArchiveResp.prototype.setArchive = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetArchiveResp} returns this
 */
proto.xcommon.GetArchiveResp.prototype.clearArchive = function() {
  return this.setArchive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetArchiveResp.prototype.hasArchive = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveArchiveReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveArchiveReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveArchiveReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveArchiveReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    archive: (f = msg.getArchive()) && proto.xcommon.Archive.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveArchiveReq}
 */
proto.xcommon.SaveArchiveReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveArchiveReq;
  return proto.xcommon.SaveArchiveReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveArchiveReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveArchiveReq}
 */
proto.xcommon.SaveArchiveReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.Archive;
      reader.readMessage(value,proto.xcommon.Archive.deserializeBinaryFromReader);
      msg.setArchive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveArchiveReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveArchiveReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveArchiveReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveArchiveReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getArchive();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.Archive.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveArchiveReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SaveArchiveReq} returns this
*/
proto.xcommon.SaveArchiveReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveArchiveReq} returns this
 */
proto.xcommon.SaveArchiveReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveArchiveReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Archive Archive = 2;
 * @return {?proto.xcommon.Archive}
 */
proto.xcommon.SaveArchiveReq.prototype.getArchive = function() {
  return /** @type{?proto.xcommon.Archive} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Archive, 2));
};


/**
 * @param {?proto.xcommon.Archive|undefined} value
 * @return {!proto.xcommon.SaveArchiveReq} returns this
*/
proto.xcommon.SaveArchiveReq.prototype.setArchive = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveArchiveReq} returns this
 */
proto.xcommon.SaveArchiveReq.prototype.clearArchive = function() {
  return this.setArchive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveArchiveReq.prototype.hasArchive = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveArchiveResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveArchiveResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveArchiveResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveArchiveResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    archiveid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveArchiveResp}
 */
proto.xcommon.SaveArchiveResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveArchiveResp;
  return proto.xcommon.SaveArchiveResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveArchiveResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveArchiveResp}
 */
proto.xcommon.SaveArchiveResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setArchiveid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveArchiveResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveArchiveResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveArchiveResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveArchiveResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getArchiveid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveArchiveResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SaveArchiveResp} returns this
*/
proto.xcommon.SaveArchiveResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveArchiveResp} returns this
 */
proto.xcommon.SaveArchiveResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveArchiveResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 ArchiveID = 2;
 * @return {number}
 */
proto.xcommon.SaveArchiveResp.prototype.getArchiveid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveArchiveResp} returns this
 */
proto.xcommon.SaveArchiveResp.prototype.setArchiveid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DeleteArchiveReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DeleteArchiveReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DeleteArchiveReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteArchiveReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    archive: (f = msg.getArchive()) && proto.xcommon.Archive.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DeleteArchiveReq}
 */
proto.xcommon.DeleteArchiveReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DeleteArchiveReq;
  return proto.xcommon.DeleteArchiveReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DeleteArchiveReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DeleteArchiveReq}
 */
proto.xcommon.DeleteArchiveReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.Archive;
      reader.readMessage(value,proto.xcommon.Archive.deserializeBinaryFromReader);
      msg.setArchive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DeleteArchiveReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DeleteArchiveReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DeleteArchiveReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteArchiveReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getArchive();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.Archive.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DeleteArchiveReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.DeleteArchiveReq} returns this
*/
proto.xcommon.DeleteArchiveReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DeleteArchiveReq} returns this
 */
proto.xcommon.DeleteArchiveReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DeleteArchiveReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Archive Archive = 2;
 * @return {?proto.xcommon.Archive}
 */
proto.xcommon.DeleteArchiveReq.prototype.getArchive = function() {
  return /** @type{?proto.xcommon.Archive} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Archive, 2));
};


/**
 * @param {?proto.xcommon.Archive|undefined} value
 * @return {!proto.xcommon.DeleteArchiveReq} returns this
*/
proto.xcommon.DeleteArchiveReq.prototype.setArchive = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DeleteArchiveReq} returns this
 */
proto.xcommon.DeleteArchiveReq.prototype.clearArchive = function() {
  return this.setArchive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DeleteArchiveReq.prototype.hasArchive = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DeleteArchiveResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DeleteArchiveResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DeleteArchiveResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteArchiveResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DeleteArchiveResp}
 */
proto.xcommon.DeleteArchiveResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DeleteArchiveResp;
  return proto.xcommon.DeleteArchiveResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DeleteArchiveResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DeleteArchiveResp}
 */
proto.xcommon.DeleteArchiveResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DeleteArchiveResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DeleteArchiveResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DeleteArchiveResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteArchiveResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DeleteArchiveResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.DeleteArchiveResp} returns this
*/
proto.xcommon.DeleteArchiveResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DeleteArchiveResp} returns this
 */
proto.xcommon.DeleteArchiveResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DeleteArchiveResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.Archive.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.Archive.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.Archive} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Archive.toObject = function(includeInstance, msg) {
  var f, obj = {
    updatetime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    archiveid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    personal: (f = msg.getPersonal()) && proto.xcommon.ArchivePersonal.toObject(includeInstance, f),
    identity: (f = msg.getIdentity()) && proto.xcommon.ArchiveIdentity.toObject(includeInstance, f),
    work: (f = msg.getWork()) && proto.xcommon.ArchiveWork.toObject(includeInstance, f),
    family: (f = msg.getFamily()) && proto.xcommon.ArchiveFamily.toObject(includeInstance, f),
    occupancy: (f = msg.getOccupancy()) && proto.xcommon.ArchiveOccupancys.toObject(includeInstance, f),
    reward: (f = msg.getReward()) && proto.xcommon.ArchiveRewards.toObject(includeInstance, f),
    office: (f = msg.getOffice()) && proto.xcommon.ArchiveOffice.toObject(includeInstance, f),
    attachment: (f = msg.getAttachment()) && proto.xcommon.ArchiveAttachments.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.Archive}
 */
proto.xcommon.Archive.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.Archive;
  return proto.xcommon.Archive.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.Archive} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.Archive}
 */
proto.xcommon.Archive.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatetime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setArchiveid(value);
      break;
    case 3:
      var value = new proto.xcommon.ArchivePersonal;
      reader.readMessage(value,proto.xcommon.ArchivePersonal.deserializeBinaryFromReader);
      msg.setPersonal(value);
      break;
    case 4:
      var value = new proto.xcommon.ArchiveIdentity;
      reader.readMessage(value,proto.xcommon.ArchiveIdentity.deserializeBinaryFromReader);
      msg.setIdentity(value);
      break;
    case 5:
      var value = new proto.xcommon.ArchiveWork;
      reader.readMessage(value,proto.xcommon.ArchiveWork.deserializeBinaryFromReader);
      msg.setWork(value);
      break;
    case 6:
      var value = new proto.xcommon.ArchiveFamily;
      reader.readMessage(value,proto.xcommon.ArchiveFamily.deserializeBinaryFromReader);
      msg.setFamily(value);
      break;
    case 7:
      var value = new proto.xcommon.ArchiveOccupancys;
      reader.readMessage(value,proto.xcommon.ArchiveOccupancys.deserializeBinaryFromReader);
      msg.setOccupancy(value);
      break;
    case 8:
      var value = new proto.xcommon.ArchiveRewards;
      reader.readMessage(value,proto.xcommon.ArchiveRewards.deserializeBinaryFromReader);
      msg.setReward(value);
      break;
    case 9:
      var value = new proto.xcommon.ArchiveOffice;
      reader.readMessage(value,proto.xcommon.ArchiveOffice.deserializeBinaryFromReader);
      msg.setOffice(value);
      break;
    case 10:
      var value = new proto.xcommon.ArchiveAttachments;
      reader.readMessage(value,proto.xcommon.ArchiveAttachments.deserializeBinaryFromReader);
      msg.setAttachment(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.Archive.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.Archive.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.Archive} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Archive.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdatetime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getArchiveid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPersonal();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.ArchivePersonal.serializeBinaryToWriter
    );
  }
  f = message.getIdentity();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.xcommon.ArchiveIdentity.serializeBinaryToWriter
    );
  }
  f = message.getWork();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.xcommon.ArchiveWork.serializeBinaryToWriter
    );
  }
  f = message.getFamily();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.xcommon.ArchiveFamily.serializeBinaryToWriter
    );
  }
  f = message.getOccupancy();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.xcommon.ArchiveOccupancys.serializeBinaryToWriter
    );
  }
  f = message.getReward();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.xcommon.ArchiveRewards.serializeBinaryToWriter
    );
  }
  f = message.getOffice();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.xcommon.ArchiveOffice.serializeBinaryToWriter
    );
  }
  f = message.getAttachment();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.xcommon.ArchiveAttachments.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
};


/**
 * optional int64 UpdateTime = 1;
 * @return {number}
 */
proto.xcommon.Archive.prototype.getUpdatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.Archive} returns this
 */
proto.xcommon.Archive.prototype.setUpdatetime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 ArchiveID = 2;
 * @return {number}
 */
proto.xcommon.Archive.prototype.getArchiveid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.Archive} returns this
 */
proto.xcommon.Archive.prototype.setArchiveid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional ArchivePersonal Personal = 3;
 * @return {?proto.xcommon.ArchivePersonal}
 */
proto.xcommon.Archive.prototype.getPersonal = function() {
  return /** @type{?proto.xcommon.ArchivePersonal} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.ArchivePersonal, 3));
};


/**
 * @param {?proto.xcommon.ArchivePersonal|undefined} value
 * @return {!proto.xcommon.Archive} returns this
*/
proto.xcommon.Archive.prototype.setPersonal = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.Archive} returns this
 */
proto.xcommon.Archive.prototype.clearPersonal = function() {
  return this.setPersonal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.Archive.prototype.hasPersonal = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ArchiveIdentity Identity = 4;
 * @return {?proto.xcommon.ArchiveIdentity}
 */
proto.xcommon.Archive.prototype.getIdentity = function() {
  return /** @type{?proto.xcommon.ArchiveIdentity} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.ArchiveIdentity, 4));
};


/**
 * @param {?proto.xcommon.ArchiveIdentity|undefined} value
 * @return {!proto.xcommon.Archive} returns this
*/
proto.xcommon.Archive.prototype.setIdentity = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.Archive} returns this
 */
proto.xcommon.Archive.prototype.clearIdentity = function() {
  return this.setIdentity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.Archive.prototype.hasIdentity = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ArchiveWork Work = 5;
 * @return {?proto.xcommon.ArchiveWork}
 */
proto.xcommon.Archive.prototype.getWork = function() {
  return /** @type{?proto.xcommon.ArchiveWork} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.ArchiveWork, 5));
};


/**
 * @param {?proto.xcommon.ArchiveWork|undefined} value
 * @return {!proto.xcommon.Archive} returns this
*/
proto.xcommon.Archive.prototype.setWork = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.Archive} returns this
 */
proto.xcommon.Archive.prototype.clearWork = function() {
  return this.setWork(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.Archive.prototype.hasWork = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ArchiveFamily Family = 6;
 * @return {?proto.xcommon.ArchiveFamily}
 */
proto.xcommon.Archive.prototype.getFamily = function() {
  return /** @type{?proto.xcommon.ArchiveFamily} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.ArchiveFamily, 6));
};


/**
 * @param {?proto.xcommon.ArchiveFamily|undefined} value
 * @return {!proto.xcommon.Archive} returns this
*/
proto.xcommon.Archive.prototype.setFamily = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.Archive} returns this
 */
proto.xcommon.Archive.prototype.clearFamily = function() {
  return this.setFamily(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.Archive.prototype.hasFamily = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ArchiveOccupancys Occupancy = 7;
 * @return {?proto.xcommon.ArchiveOccupancys}
 */
proto.xcommon.Archive.prototype.getOccupancy = function() {
  return /** @type{?proto.xcommon.ArchiveOccupancys} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.ArchiveOccupancys, 7));
};


/**
 * @param {?proto.xcommon.ArchiveOccupancys|undefined} value
 * @return {!proto.xcommon.Archive} returns this
*/
proto.xcommon.Archive.prototype.setOccupancy = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.Archive} returns this
 */
proto.xcommon.Archive.prototype.clearOccupancy = function() {
  return this.setOccupancy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.Archive.prototype.hasOccupancy = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional ArchiveRewards Reward = 8;
 * @return {?proto.xcommon.ArchiveRewards}
 */
proto.xcommon.Archive.prototype.getReward = function() {
  return /** @type{?proto.xcommon.ArchiveRewards} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.ArchiveRewards, 8));
};


/**
 * @param {?proto.xcommon.ArchiveRewards|undefined} value
 * @return {!proto.xcommon.Archive} returns this
*/
proto.xcommon.Archive.prototype.setReward = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.Archive} returns this
 */
proto.xcommon.Archive.prototype.clearReward = function() {
  return this.setReward(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.Archive.prototype.hasReward = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ArchiveOffice Office = 9;
 * @return {?proto.xcommon.ArchiveOffice}
 */
proto.xcommon.Archive.prototype.getOffice = function() {
  return /** @type{?proto.xcommon.ArchiveOffice} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.ArchiveOffice, 9));
};


/**
 * @param {?proto.xcommon.ArchiveOffice|undefined} value
 * @return {!proto.xcommon.Archive} returns this
*/
proto.xcommon.Archive.prototype.setOffice = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.Archive} returns this
 */
proto.xcommon.Archive.prototype.clearOffice = function() {
  return this.setOffice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.Archive.prototype.hasOffice = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ArchiveAttachments Attachment = 10;
 * @return {?proto.xcommon.ArchiveAttachments}
 */
proto.xcommon.Archive.prototype.getAttachment = function() {
  return /** @type{?proto.xcommon.ArchiveAttachments} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.ArchiveAttachments, 10));
};


/**
 * @param {?proto.xcommon.ArchiveAttachments|undefined} value
 * @return {!proto.xcommon.Archive} returns this
*/
proto.xcommon.Archive.prototype.setAttachment = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.Archive} returns this
 */
proto.xcommon.Archive.prototype.clearAttachment = function() {
  return this.setAttachment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.Archive.prototype.hasAttachment = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional int64 UserID = 11;
 * @return {number}
 */
proto.xcommon.Archive.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.Archive} returns this
 */
proto.xcommon.Archive.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchivePersonal.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchivePersonal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchivePersonal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchivePersonal.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 2, 0),
    birthday: jspb.Message.getFieldWithDefault(msg, 3, 0),
    mobile: jspb.Message.getFieldWithDefault(msg, 4, ""),
    email: jspb.Message.getFieldWithDefault(msg, 5, ""),
    panelstatus: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchivePersonal}
 */
proto.xcommon.ArchivePersonal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchivePersonal;
  return proto.xcommon.ArchivePersonal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchivePersonal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchivePersonal}
 */
proto.xcommon.ArchivePersonal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.Gender} */ (reader.readEnum());
      msg.setGender(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBirthday(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.ArchivePanelStatus} */ (reader.readEnum());
      msg.setPanelstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchivePersonal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchivePersonal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchivePersonal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchivePersonal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGender();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getBirthday();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPanelstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.xcommon.ArchivePersonal.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchivePersonal} returns this
 */
proto.xcommon.ArchivePersonal.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Gender Gender = 2;
 * @return {!proto.xcommon.Gender}
 */
proto.xcommon.ArchivePersonal.prototype.getGender = function() {
  return /** @type {!proto.xcommon.Gender} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.Gender} value
 * @return {!proto.xcommon.ArchivePersonal} returns this
 */
proto.xcommon.ArchivePersonal.prototype.setGender = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 Birthday = 3;
 * @return {number}
 */
proto.xcommon.ArchivePersonal.prototype.getBirthday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ArchivePersonal} returns this
 */
proto.xcommon.ArchivePersonal.prototype.setBirthday = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Mobile = 4;
 * @return {string}
 */
proto.xcommon.ArchivePersonal.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchivePersonal} returns this
 */
proto.xcommon.ArchivePersonal.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Email = 5;
 * @return {string}
 */
proto.xcommon.ArchivePersonal.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchivePersonal} returns this
 */
proto.xcommon.ArchivePersonal.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional ArchivePanelStatus PanelStatus = 6;
 * @return {!proto.xcommon.ArchivePanelStatus}
 */
proto.xcommon.ArchivePersonal.prototype.getPanelstatus = function() {
  return /** @type {!proto.xcommon.ArchivePanelStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.xcommon.ArchivePanelStatus} value
 * @return {!proto.xcommon.ArchivePersonal} returns this
 */
proto.xcommon.ArchivePersonal.prototype.setPanelstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchiveIdentity.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchiveIdentity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchiveIdentity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveIdentity.toObject = function(includeInstance, msg) {
  var f, obj = {
    identity: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rfc: jspb.Message.getFieldWithDefault(msg, 2, ""),
    curp: jspb.Message.getFieldWithDefault(msg, 3, ""),
    identityphoto: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    panelstatus: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchiveIdentity}
 */
proto.xcommon.ArchiveIdentity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchiveIdentity;
  return proto.xcommon.ArchiveIdentity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchiveIdentity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchiveIdentity}
 */
proto.xcommon.ArchiveIdentity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentity(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRfc(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurp(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setIdentityphoto(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.ArchivePanelStatus} */ (reader.readEnum());
      msg.setPanelstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchiveIdentity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchiveIdentity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchiveIdentity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveIdentity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentity();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRfc();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurp();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIdentityphoto();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getPanelstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string Identity = 1;
 * @return {string}
 */
proto.xcommon.ArchiveIdentity.prototype.getIdentity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveIdentity} returns this
 */
proto.xcommon.ArchiveIdentity.prototype.setIdentity = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string RFC = 2;
 * @return {string}
 */
proto.xcommon.ArchiveIdentity.prototype.getRfc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveIdentity} returns this
 */
proto.xcommon.ArchiveIdentity.prototype.setRfc = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string CURP = 3;
 * @return {string}
 */
proto.xcommon.ArchiveIdentity.prototype.getCurp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveIdentity} returns this
 */
proto.xcommon.ArchiveIdentity.prototype.setCurp = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 IdentityPhoto = 4;
 * @return {string}
 */
proto.xcommon.ArchiveIdentity.prototype.getIdentityphoto = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveIdentity} returns this
 */
proto.xcommon.ArchiveIdentity.prototype.setIdentityphoto = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional ArchivePanelStatus PanelStatus = 5;
 * @return {!proto.xcommon.ArchivePanelStatus}
 */
proto.xcommon.ArchiveIdentity.prototype.getPanelstatus = function() {
  return /** @type {!proto.xcommon.ArchivePanelStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.xcommon.ArchivePanelStatus} value
 * @return {!proto.xcommon.ArchiveIdentity} returns this
 */
proto.xcommon.ArchiveIdentity.prototype.setPanelstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchiveWork.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchiveWork.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchiveWork} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveWork.toObject = function(includeInstance, msg) {
  var f, obj = {
    employeeid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    role: jspb.Message.getFieldWithDefault(msg, 2, ""),
    panelstatus: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchiveWork}
 */
proto.xcommon.ArchiveWork.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchiveWork;
  return proto.xcommon.ArchiveWork.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchiveWork} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchiveWork}
 */
proto.xcommon.ArchiveWork.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.ArchivePanelStatus} */ (reader.readEnum());
      msg.setPanelstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchiveWork.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchiveWork.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchiveWork} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveWork.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPanelstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string EmployeeId = 1;
 * @return {string}
 */
proto.xcommon.ArchiveWork.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveWork} returns this
 */
proto.xcommon.ArchiveWork.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Role = 2;
 * @return {string}
 */
proto.xcommon.ArchiveWork.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveWork} returns this
 */
proto.xcommon.ArchiveWork.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ArchivePanelStatus PanelStatus = 3;
 * @return {!proto.xcommon.ArchivePanelStatus}
 */
proto.xcommon.ArchiveWork.prototype.getPanelstatus = function() {
  return /** @type {!proto.xcommon.ArchivePanelStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.xcommon.ArchivePanelStatus} value
 * @return {!proto.xcommon.ArchiveWork} returns this
 */
proto.xcommon.ArchiveWork.prototype.setPanelstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchiveContact.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchiveContact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchiveContact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveContact.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    contact: jspb.Message.getFieldWithDefault(msg, 2, ""),
    relationship: jspb.Message.getFieldWithDefault(msg, 3, 0),
    panelstatus: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchiveContact}
 */
proto.xcommon.ArchiveContact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchiveContact;
  return proto.xcommon.ArchiveContact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchiveContact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchiveContact}
 */
proto.xcommon.ArchiveContact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.Relationship} */ (reader.readEnum());
      msg.setRelationship(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.ArchivePanelStatus} */ (reader.readEnum());
      msg.setPanelstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchiveContact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchiveContact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchiveContact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveContact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getContact();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRelationship();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPanelstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional int64 ID = 1;
 * @return {number}
 */
proto.xcommon.ArchiveContact.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ArchiveContact} returns this
 */
proto.xcommon.ArchiveContact.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Contact = 2;
 * @return {string}
 */
proto.xcommon.ArchiveContact.prototype.getContact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveContact} returns this
 */
proto.xcommon.ArchiveContact.prototype.setContact = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Relationship Relationship = 3;
 * @return {!proto.xcommon.Relationship}
 */
proto.xcommon.ArchiveContact.prototype.getRelationship = function() {
  return /** @type {!proto.xcommon.Relationship} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.xcommon.Relationship} value
 * @return {!proto.xcommon.ArchiveContact} returns this
 */
proto.xcommon.ArchiveContact.prototype.setRelationship = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional ArchivePanelStatus PanelStatus = 4;
 * @return {!proto.xcommon.ArchivePanelStatus}
 */
proto.xcommon.ArchiveContact.prototype.getPanelstatus = function() {
  return /** @type {!proto.xcommon.ArchivePanelStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.xcommon.ArchivePanelStatus} value
 * @return {!proto.xcommon.ArchiveContact} returns this
 */
proto.xcommon.ArchiveContact.prototype.setPanelstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ArchiveFamily.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchiveFamily.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchiveFamily.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchiveFamily} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveFamily.toObject = function(includeInstance, msg) {
  var f, obj = {
    maritalstatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
    childrennumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    familyaddress: jspb.Message.getFieldWithDefault(msg, 3, ""),
    familyaddrphoto: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    contactList: jspb.Message.toObjectList(msg.getContactList(),
    proto.xcommon.ArchiveContact.toObject, includeInstance),
    panelstatus: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchiveFamily}
 */
proto.xcommon.ArchiveFamily.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchiveFamily;
  return proto.xcommon.ArchiveFamily.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchiveFamily} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchiveFamily}
 */
proto.xcommon.ArchiveFamily.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.MaritalStatus} */ (reader.readEnum());
      msg.setMaritalstatus(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChildrennumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilyaddress(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setFamilyaddrphoto(value);
      break;
    case 5:
      var value = new proto.xcommon.ArchiveContact;
      reader.readMessage(value,proto.xcommon.ArchiveContact.deserializeBinaryFromReader);
      msg.addContact(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.ArchivePanelStatus} */ (reader.readEnum());
      msg.setPanelstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchiveFamily.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchiveFamily.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchiveFamily} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveFamily.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaritalstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getChildrennumber();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFamilyaddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFamilyaddrphoto();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getContactList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.ArchiveContact.serializeBinaryToWriter
    );
  }
  f = message.getPanelstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional MaritalStatus MaritalStatus = 1;
 * @return {!proto.xcommon.MaritalStatus}
 */
proto.xcommon.ArchiveFamily.prototype.getMaritalstatus = function() {
  return /** @type {!proto.xcommon.MaritalStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.xcommon.MaritalStatus} value
 * @return {!proto.xcommon.ArchiveFamily} returns this
 */
proto.xcommon.ArchiveFamily.prototype.setMaritalstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 ChildrenNumber = 2;
 * @return {number}
 */
proto.xcommon.ArchiveFamily.prototype.getChildrennumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ArchiveFamily} returns this
 */
proto.xcommon.ArchiveFamily.prototype.setChildrennumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string FamilyAddress = 3;
 * @return {string}
 */
proto.xcommon.ArchiveFamily.prototype.getFamilyaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveFamily} returns this
 */
proto.xcommon.ArchiveFamily.prototype.setFamilyaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 FamilyAddrPhoto = 4;
 * @return {string}
 */
proto.xcommon.ArchiveFamily.prototype.getFamilyaddrphoto = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveFamily} returns this
 */
proto.xcommon.ArchiveFamily.prototype.setFamilyaddrphoto = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * repeated ArchiveContact Contact = 5;
 * @return {!Array<!proto.xcommon.ArchiveContact>}
 */
proto.xcommon.ArchiveFamily.prototype.getContactList = function() {
  return /** @type{!Array<!proto.xcommon.ArchiveContact>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ArchiveContact, 5));
};


/**
 * @param {!Array<!proto.xcommon.ArchiveContact>} value
 * @return {!proto.xcommon.ArchiveFamily} returns this
*/
proto.xcommon.ArchiveFamily.prototype.setContactList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.ArchiveContact=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ArchiveContact}
 */
proto.xcommon.ArchiveFamily.prototype.addContact = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.ArchiveContact, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.ArchiveFamily} returns this
 */
proto.xcommon.ArchiveFamily.prototype.clearContactList = function() {
  return this.setContactList([]);
};


/**
 * optional ArchivePanelStatus PanelStatus = 6;
 * @return {!proto.xcommon.ArchivePanelStatus}
 */
proto.xcommon.ArchiveFamily.prototype.getPanelstatus = function() {
  return /** @type {!proto.xcommon.ArchivePanelStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.xcommon.ArchivePanelStatus} value
 * @return {!proto.xcommon.ArchiveFamily} returns this
 */
proto.xcommon.ArchiveFamily.prototype.setPanelstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ArchiveOccupancys.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchiveOccupancys.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchiveOccupancys.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchiveOccupancys} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveOccupancys.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.ArchiveOccupancy.toObject, includeInstance),
    panelstatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchiveOccupancys}
 */
proto.xcommon.ArchiveOccupancys.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchiveOccupancys;
  return proto.xcommon.ArchiveOccupancys.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchiveOccupancys} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchiveOccupancys}
 */
proto.xcommon.ArchiveOccupancys.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.ArchiveOccupancy;
      reader.readMessage(value,proto.xcommon.ArchiveOccupancy.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.ArchivePanelStatus} */ (reader.readEnum());
      msg.setPanelstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchiveOccupancys.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchiveOccupancys.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchiveOccupancys} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveOccupancys.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.xcommon.ArchiveOccupancy.serializeBinaryToWriter
    );
  }
  f = message.getPanelstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * repeated ArchiveOccupancy List = 1;
 * @return {!Array<!proto.xcommon.ArchiveOccupancy>}
 */
proto.xcommon.ArchiveOccupancys.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.ArchiveOccupancy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ArchiveOccupancy, 1));
};


/**
 * @param {!Array<!proto.xcommon.ArchiveOccupancy>} value
 * @return {!proto.xcommon.ArchiveOccupancys} returns this
*/
proto.xcommon.ArchiveOccupancys.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.xcommon.ArchiveOccupancy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ArchiveOccupancy}
 */
proto.xcommon.ArchiveOccupancys.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.xcommon.ArchiveOccupancy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.ArchiveOccupancys} returns this
 */
proto.xcommon.ArchiveOccupancys.prototype.clearListList = function() {
  return this.setListList([]);
};


/**
 * optional ArchivePanelStatus PanelStatus = 2;
 * @return {!proto.xcommon.ArchivePanelStatus}
 */
proto.xcommon.ArchiveOccupancys.prototype.getPanelstatus = function() {
  return /** @type {!proto.xcommon.ArchivePanelStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.ArchivePanelStatus} value
 * @return {!proto.xcommon.ArchiveOccupancys} returns this
 */
proto.xcommon.ArchiveOccupancys.prototype.setPanelstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchiveOccupancy.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchiveOccupancy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchiveOccupancy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveOccupancy.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    company: jspb.Message.getFieldWithDefault(msg, 2, ""),
    position: jspb.Message.getFieldWithDefault(msg, 3, ""),
    begintime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    endtime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    panelstatus: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchiveOccupancy}
 */
proto.xcommon.ArchiveOccupancy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchiveOccupancy;
  return proto.xcommon.ArchiveOccupancy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchiveOccupancy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchiveOccupancy}
 */
proto.xcommon.ArchiveOccupancy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPosition(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBegintime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtime(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.ArchivePanelStatus} */ (reader.readEnum());
      msg.setPanelstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchiveOccupancy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchiveOccupancy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchiveOccupancy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveOccupancy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPosition();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBegintime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getEndtime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getPanelstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional int64 ID = 1;
 * @return {number}
 */
proto.xcommon.ArchiveOccupancy.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ArchiveOccupancy} returns this
 */
proto.xcommon.ArchiveOccupancy.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Company = 2;
 * @return {string}
 */
proto.xcommon.ArchiveOccupancy.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveOccupancy} returns this
 */
proto.xcommon.ArchiveOccupancy.prototype.setCompany = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Position = 3;
 * @return {string}
 */
proto.xcommon.ArchiveOccupancy.prototype.getPosition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveOccupancy} returns this
 */
proto.xcommon.ArchiveOccupancy.prototype.setPosition = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 BeginTime = 4;
 * @return {number}
 */
proto.xcommon.ArchiveOccupancy.prototype.getBegintime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ArchiveOccupancy} returns this
 */
proto.xcommon.ArchiveOccupancy.prototype.setBegintime = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 EndTime = 5;
 * @return {number}
 */
proto.xcommon.ArchiveOccupancy.prototype.getEndtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ArchiveOccupancy} returns this
 */
proto.xcommon.ArchiveOccupancy.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional ArchivePanelStatus PanelStatus = 6;
 * @return {!proto.xcommon.ArchivePanelStatus}
 */
proto.xcommon.ArchiveOccupancy.prototype.getPanelstatus = function() {
  return /** @type {!proto.xcommon.ArchivePanelStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.xcommon.ArchivePanelStatus} value
 * @return {!proto.xcommon.ArchiveOccupancy} returns this
 */
proto.xcommon.ArchiveOccupancy.prototype.setPanelstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ArchiveRewards.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchiveRewards.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchiveRewards.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchiveRewards} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveRewards.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.ArchiveReward.toObject, includeInstance),
    panelstatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchiveRewards}
 */
proto.xcommon.ArchiveRewards.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchiveRewards;
  return proto.xcommon.ArchiveRewards.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchiveRewards} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchiveRewards}
 */
proto.xcommon.ArchiveRewards.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.ArchiveReward;
      reader.readMessage(value,proto.xcommon.ArchiveReward.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.ArchivePanelStatus} */ (reader.readEnum());
      msg.setPanelstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchiveRewards.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchiveRewards.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchiveRewards} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveRewards.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.xcommon.ArchiveReward.serializeBinaryToWriter
    );
  }
  f = message.getPanelstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * repeated ArchiveReward List = 1;
 * @return {!Array<!proto.xcommon.ArchiveReward>}
 */
proto.xcommon.ArchiveRewards.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.ArchiveReward>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ArchiveReward, 1));
};


/**
 * @param {!Array<!proto.xcommon.ArchiveReward>} value
 * @return {!proto.xcommon.ArchiveRewards} returns this
*/
proto.xcommon.ArchiveRewards.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.xcommon.ArchiveReward=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ArchiveReward}
 */
proto.xcommon.ArchiveRewards.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.xcommon.ArchiveReward, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.ArchiveRewards} returns this
 */
proto.xcommon.ArchiveRewards.prototype.clearListList = function() {
  return this.setListList([]);
};


/**
 * optional ArchivePanelStatus PanelStatus = 2;
 * @return {!proto.xcommon.ArchivePanelStatus}
 */
proto.xcommon.ArchiveRewards.prototype.getPanelstatus = function() {
  return /** @type {!proto.xcommon.ArchivePanelStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.ArchivePanelStatus} value
 * @return {!proto.xcommon.ArchiveRewards} returns this
 */
proto.xcommon.ArchiveRewards.prototype.setPanelstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchiveReward.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchiveReward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchiveReward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveReward.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rewardtype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rewardcategory: jspb.Message.getFieldWithDefault(msg, 3, 0),
    rewarditem: jspb.Message.getFieldWithDefault(msg, 4, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    remark: jspb.Message.getFieldWithDefault(msg, 6, ""),
    panelstatus: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchiveReward}
 */
proto.xcommon.ArchiveReward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchiveReward;
  return proto.xcommon.ArchiveReward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchiveReward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchiveReward}
 */
proto.xcommon.ArchiveReward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.RewardType} */ (reader.readEnum());
      msg.setRewardtype(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.RewardCategory} */ (reader.readEnum());
      msg.setRewardcategory(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.RewardItem} */ (reader.readEnum());
      msg.setRewarditem(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.ArchivePanelStatus} */ (reader.readEnum());
      msg.setPanelstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchiveReward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchiveReward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchiveReward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveReward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRewardtype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRewardcategory();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getRewarditem();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPanelstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional int64 ID = 1;
 * @return {number}
 */
proto.xcommon.ArchiveReward.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ArchiveReward} returns this
 */
proto.xcommon.ArchiveReward.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional RewardType RewardType = 2;
 * @return {!proto.xcommon.RewardType}
 */
proto.xcommon.ArchiveReward.prototype.getRewardtype = function() {
  return /** @type {!proto.xcommon.RewardType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.RewardType} value
 * @return {!proto.xcommon.ArchiveReward} returns this
 */
proto.xcommon.ArchiveReward.prototype.setRewardtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional RewardCategory RewardCategory = 3;
 * @return {!proto.xcommon.RewardCategory}
 */
proto.xcommon.ArchiveReward.prototype.getRewardcategory = function() {
  return /** @type {!proto.xcommon.RewardCategory} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.xcommon.RewardCategory} value
 * @return {!proto.xcommon.ArchiveReward} returns this
 */
proto.xcommon.ArchiveReward.prototype.setRewardcategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional RewardItem RewardItem = 4;
 * @return {!proto.xcommon.RewardItem}
 */
proto.xcommon.ArchiveReward.prototype.getRewarditem = function() {
  return /** @type {!proto.xcommon.RewardItem} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.xcommon.RewardItem} value
 * @return {!proto.xcommon.ArchiveReward} returns this
 */
proto.xcommon.ArchiveReward.prototype.setRewarditem = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 Amount = 5;
 * @return {number}
 */
proto.xcommon.ArchiveReward.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ArchiveReward} returns this
 */
proto.xcommon.ArchiveReward.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string Remark = 6;
 * @return {string}
 */
proto.xcommon.ArchiveReward.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveReward} returns this
 */
proto.xcommon.ArchiveReward.prototype.setRemark = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional ArchivePanelStatus PanelStatus = 7;
 * @return {!proto.xcommon.ArchivePanelStatus}
 */
proto.xcommon.ArchiveReward.prototype.getPanelstatus = function() {
  return /** @type {!proto.xcommon.ArchivePanelStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.xcommon.ArchivePanelStatus} value
 * @return {!proto.xcommon.ArchiveReward} returns this
 */
proto.xcommon.ArchiveReward.prototype.setPanelstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchiveOffice.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchiveOffice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchiveOffice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveOffice.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    officestatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    officetime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchiveOffice}
 */
proto.xcommon.ArchiveOffice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchiveOffice;
  return proto.xcommon.ArchiveOffice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchiveOffice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchiveOffice}
 */
proto.xcommon.ArchiveOffice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.OfficeStatus} */ (reader.readEnum());
      msg.setOfficestatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOfficetime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchiveOffice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchiveOffice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchiveOffice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveOffice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOfficestatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOfficetime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 ID = 1;
 * @return {number}
 */
proto.xcommon.ArchiveOffice.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ArchiveOffice} returns this
 */
proto.xcommon.ArchiveOffice.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional OfficeStatus OfficeStatus = 2;
 * @return {!proto.xcommon.OfficeStatus}
 */
proto.xcommon.ArchiveOffice.prototype.getOfficestatus = function() {
  return /** @type {!proto.xcommon.OfficeStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.OfficeStatus} value
 * @return {!proto.xcommon.ArchiveOffice} returns this
 */
proto.xcommon.ArchiveOffice.prototype.setOfficestatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 OfficeTime = 3;
 * @return {number}
 */
proto.xcommon.ArchiveOffice.prototype.getOfficetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ArchiveOffice} returns this
 */
proto.xcommon.ArchiveOffice.prototype.setOfficetime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string reason = 4;
 * @return {string}
 */
proto.xcommon.ArchiveOffice.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveOffice} returns this
 */
proto.xcommon.ArchiveOffice.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ArchiveAttachments.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchiveAttachments.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchiveAttachments.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchiveAttachments} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveAttachments.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.ArchiveAttachment.toObject, includeInstance),
    panelstatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchiveAttachments}
 */
proto.xcommon.ArchiveAttachments.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchiveAttachments;
  return proto.xcommon.ArchiveAttachments.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchiveAttachments} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchiveAttachments}
 */
proto.xcommon.ArchiveAttachments.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.ArchiveAttachment;
      reader.readMessage(value,proto.xcommon.ArchiveAttachment.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.ArchivePanelStatus} */ (reader.readEnum());
      msg.setPanelstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchiveAttachments.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchiveAttachments.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchiveAttachments} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveAttachments.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.xcommon.ArchiveAttachment.serializeBinaryToWriter
    );
  }
  f = message.getPanelstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * repeated ArchiveAttachment List = 1;
 * @return {!Array<!proto.xcommon.ArchiveAttachment>}
 */
proto.xcommon.ArchiveAttachments.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.ArchiveAttachment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ArchiveAttachment, 1));
};


/**
 * @param {!Array<!proto.xcommon.ArchiveAttachment>} value
 * @return {!proto.xcommon.ArchiveAttachments} returns this
*/
proto.xcommon.ArchiveAttachments.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.xcommon.ArchiveAttachment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ArchiveAttachment}
 */
proto.xcommon.ArchiveAttachments.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.xcommon.ArchiveAttachment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.ArchiveAttachments} returns this
 */
proto.xcommon.ArchiveAttachments.prototype.clearListList = function() {
  return this.setListList([]);
};


/**
 * optional ArchivePanelStatus PanelStatus = 2;
 * @return {!proto.xcommon.ArchivePanelStatus}
 */
proto.xcommon.ArchiveAttachments.prototype.getPanelstatus = function() {
  return /** @type {!proto.xcommon.ArchivePanelStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.ArchivePanelStatus} value
 * @return {!proto.xcommon.ArchiveAttachments} returns this
 */
proto.xcommon.ArchiveAttachments.prototype.setPanelstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ArchiveAttachment.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ArchiveAttachment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ArchiveAttachment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveAttachment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    attachmentname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    attachmentid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    panelstatus: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ArchiveAttachment}
 */
proto.xcommon.ArchiveAttachment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ArchiveAttachment;
  return proto.xcommon.ArchiveAttachment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ArchiveAttachment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ArchiveAttachment}
 */
proto.xcommon.ArchiveAttachment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttachmentname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAttachmentid(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.ArchivePanelStatus} */ (reader.readEnum());
      msg.setPanelstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ArchiveAttachment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ArchiveAttachment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ArchiveAttachment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ArchiveAttachment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAttachmentname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAttachmentid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getPanelstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional int64 ID = 1;
 * @return {number}
 */
proto.xcommon.ArchiveAttachment.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ArchiveAttachment} returns this
 */
proto.xcommon.ArchiveAttachment.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string AttachmentName = 2;
 * @return {string}
 */
proto.xcommon.ArchiveAttachment.prototype.getAttachmentname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveAttachment} returns this
 */
proto.xcommon.ArchiveAttachment.prototype.setAttachmentname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 AttachmentID = 3;
 * @return {string}
 */
proto.xcommon.ArchiveAttachment.prototype.getAttachmentid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ArchiveAttachment} returns this
 */
proto.xcommon.ArchiveAttachment.prototype.setAttachmentid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional ArchivePanelStatus PanelStatus = 4;
 * @return {!proto.xcommon.ArchivePanelStatus}
 */
proto.xcommon.ArchiveAttachment.prototype.getPanelstatus = function() {
  return /** @type {!proto.xcommon.ArchivePanelStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.xcommon.ArchivePanelStatus} value
 * @return {!proto.xcommon.ArchiveAttachment} returns this
 */
proto.xcommon.ArchiveAttachment.prototype.setPanelstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.xcommon.Gender = {
  GENDER_UNSPECIFIED: 0,
  GENDER_MALE: 1,
  GENDER_FEMALE: 2
};

/**
 * @enum {number}
 */
proto.xcommon.MaritalStatus = {
  MARITAL_STATUS_UNSPECIFIED: 0,
  MARITAL_STATUS_MARRIED: 1,
  MARITAL_STATUS_SINGLE: 2,
  MARITAL_STATUS_COHABIT: 3,
  MARITAL_STATUS_DIVORCED: 4
};

/**
 * @enum {number}
 */
proto.xcommon.Relationship = {
  RELATIONSHIP_UNSPECIFIED: 0,
  RELATIONSHIP_PARENT: 1,
  RELATIONSHIP_SPOUSE: 2,
  RELATIONSHIP_CHILDREN: 3,
  RELATIONSHIP_FRIEND: 4
};

/**
 * @enum {number}
 */
proto.xcommon.RewardType = {
  REWARD_TYPE_UNSPECIFIED: 0,
  REWARD_TYPE_PRIZE: 1,
  REWARD_TYPE_PENALTY: 2
};

/**
 * @enum {number}
 */
proto.xcommon.RewardCategory = {
  REWARD_CATEGORY_UNSPECIFIED: 0,
  REWARD_CATEGORY_LEGAL: 1,
  REWARD_CATEGORY_BUSINESS: 2,
  REWARD_CATEGORY_DISCIPLINE: 3
};

/**
 * @enum {number}
 */
proto.xcommon.RewardItem = {
  REWARD_ITEM_UNSPECIFIED: 0,
  REWARD_ITEM_VERBAL: 1,
  REWARD_ITEM_COMMITMENT: 2,
  REWARD_ITEM_LETTER: 3
};

/**
 * @enum {number}
 */
proto.xcommon.OfficeStatus = {
  OFFICE_STATUS_UNSPECIFIED: 0,
  OFFICE_STATUS_ON: 1,
  OFFICE_STATUS_OFF: 2
};

/**
 * @enum {number}
 */
proto.xcommon.ArchivePanelStatus = {
  ARCHIVE_PANEL_STATUS_NORMAL: 0,
  ARCHIVE_PANEL_STATUS_DELETED: 1
};

module.exports = proto.xcommon;
